import { z } from "zod";

/**
 * Schema for MergeReservationPayload (POST /api/v4/booking/merge-reservation)
 */
export const MergeReservationPayloadSchema = z.object({
    booking_room_id: z.string().uuid(),
});

export type MergeReservationPayloadType = z.infer<typeof MergeReservationPayloadSchema>;

/**
 * Satu baris syarat merge dari `GET /booking/merge-reservation-candidate`.
 * `expected`/`actual` berisi nilai yang bisa dibaca manusia (nomor kamar, nama
 * room type, dst) — bukan UUID — supaya UI bisa menjelaskan apa yang belum sama.
 */
export const MergeRuleSchema = z.object({
    key: z.string(),
    label: z.string(),
    passed: z.boolean(),
    expected: z.string().nullable().optional(),
    actual: z.string().nullable().optional(),
});

export const MergeSegmentSchema = z.object({
    id: z.string(),
    checkin_date: z.string(),
    checkout_date: z.string(),
    room_number: z.string().nullable(),
    room_type_name: z.string().nullable(),
    rate_plan_name: z.string().nullable(),
    status: z.string().nullable(),
    mark: z.string().nullable(),
});

export const MergeCandidateSchema = z.object({
    can_merge: z.boolean(),
    rules: z.array(MergeRuleSchema),
    segment_1: MergeSegmentSchema.nullable(),
    segment_2: MergeSegmentSchema.nullable(),
    result_preview: z.object({
        checkin_date: z.string(),
        checkout_date: z.string(),
        nights: z.number(),
    }).nullable(),
});

export type MergeRuleType = z.infer<typeof MergeRuleSchema>;
export type MergeSegmentType = z.infer<typeof MergeSegmentSchema>;
export type MergeCandidateType = z.infer<typeof MergeCandidateSchema>;
